import React from "react";
import { Card } from "react-bootstrap";
import { primaryColor } from "../config/colors";
import { EMPTY_DATA_ILLUSTRATER } from "../config";

function EmptyOrderComponent({ title, displayImg }) {
  return (
    // <Card className="flex-grow-1 shadow-sm rounded w-100 d-flex flex-column justify-content-center align-items-center">
    //   <img src={displayImg || EMPTY_DATA_ILLUSTRATER} />
    //   <h5 className="p-0 m-0" style={{ color: primaryColor }}>
    //     {title}
    //   </h5>
    // </Card>
    <div className="text-center my-4">
      <img src={displayImg || EMPTY_DATA_ILLUSTRATER} />
      <p className="text-primary my-2" style={{fontSize: 16}}>{title}</p>
    </div>
  );
}

export default EmptyOrderComponent;
